<template>
    <div>
        <header class="header-warpper">
            <div class="main clearfix" style="position: relative">
                <!-- logo -->
                <div class="logo fl">
                    <img src="../../static/image/logo.png" alt="" />
                    <!-- <img src="../../static/image/pc_logo5.png" alt="" /> -->
                    <div style="display: inline-block">
                        <span class="tit">中国建筑文化中心培训中心 </span>
                        <span class="sub-tit">Training Center of China Architectural Culture Center</span>
                    </div>

                    <div style="position: absolute; top: 25px; right: 100px">
                        <img src="../../static/image/code.jpg" alt="" style="height: 94px" />
                    </div>
                </div>
            </div>
        </header>

        <div class="nav_box">
            <ul class="cf nav clearfix">
                <li class="fl" v-for="(item, index) in menuList" :key="index" @click.stop="routeTo(item)" @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave(index)">
                    <a>{{ item.title }}</a>
                    <ul class="nav_down_w1" :class="{ open: isActive == index }">
                        <li v-for="(itemSub, index) in item.children" :key="index" @click.stop="routeSubTo(itemSub)">
                            <a>{{ itemSub.title }}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false,
            menuList: [
                {
                    name: "HomePage",
                    url: "/index/HomePage",
                    title: "首页",
                    style: "color:#366df0",
                },
                {
                    name: "AboutUsList",
                    url: "/index/AboutUsList",
                    title: "中心概况",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "中心介绍",
                            url: "/index/AboutUsList",
                            contentType: "富文本",
                            type: "1",
                        },
                        {
                            title: "主要业务",
                            url: "/index/AboutUsList",
                            contentType: "富文本",
                            type: "1",
                        },
                        {
                            title: "联系方式",
                            url: "/index/AboutUsList",
                            contentType: "富文本",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "DynamicList",
                    url: "/index/DynamicList",
                    title: "新闻动态",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "行业动态",
                            id: "1552487425756987393",
                            contentType: "简单列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "工作信息",
                            id: "1552477578156048385",
                            contentType: "简单列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "重要声明",
                            id: "1600310979217883137",
                            contentType: "简单列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                    ],
                },
                // {
                //     name: "ProjectList",
                //     url: "/index/ProjectList",
                //     title: "专题培训",
                //     style: "color:#366df0",
                //     children: [
                // {
                //     id: "1552553767805665281",
                //     title: "中级注册安全工程师",
                //     url: "/index/ProjectList",
                //     type: "1",
                // },
                // {
                //     id: "1552553886944870402",
                //     title: "一级建造师",
                //     url: "/index/ProjectList",
                //     type: "1",
                // },
                // {
                //     id: "1552553938815827969",
                //     title: "BIM基础应用专业人才",
                //     url: "/index/ProjectList",
                //     type: "1",
                // },
                // {
                //     id: "1602253905363800065",
                //     title: "BIM工程应用专业人才",
                //     url: "/index/ProjectList",
                //     type: "1",
                // },

                //  {
                //     id: "1552553938815827969",
                //     title: "BIM基础应用专业人才",
                //     url: "https://www.tccacc.net/#/index/examChapter",
                //     type: "2",
                // },
                // {
                //     id: "1602253905363800065",
                //     title: "BIM工程应用专业人才",
                //     url: "https://www.tccacc.net/#/index/examChapter",
                //     type: "2",
                // },

                // {
                //     id: "1602254061370937345",
                //     title: "碳排放管理师",
                //     url: "/index/ProjectList",
                //     type: "1",
                // },
                // {
                //     title: "网络教学",
                //     url: "http://www.tccacc.net/",
                //     type: "2",
                // },
                // ],
                // },
                {
                    name: "CertSearch",
                    url: "/index/CertSearch",
                    title: "证书",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "BIM证书查询",
                            url: "https://bim.tccacc.com/#/index/certquery",
                            type: "2",
                        },
                        {
                            title: "其它证书查询",
                            url: "/index/CertQuery",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "MaterialList",
                    url: "/index/MaterialList",
                    title: "资料下载",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "学习资料",
                            id: "1562359332169953282",
                            contentType: "简单列表",
                            url: "/index/MaterialList",
                            type: "1",
                        },
                        {
                            title: "设计案例",
                            id: "1592826663357104130",
                            contentType: "简单列表",
                            url: "/index/MaterialList",
                            type: "1",
                        },
                    ],
                },
            ],
        };
    },

    watch: {
        $route: {
            handler(newVal) {
                if (newVal.query.activeName) {
                    this.$emit("changeActiveStep", newVal.query.activeName);
                }
            },
        },
    },

    methods: {
        handleMouseEnter(i) {
            this.isActive = i;
        },

        handleMouseLeave(i) {
            this.isActive = 999;
        },
        routeTo(item) {
            if (item.title == "网络教学") {
                window.open(item.url);
            } else if (item.title == "专题培训") {
                this.$router.push({
                    path: item.url,
                    query: {
                        id: "1552553767805665281",
                    },
                });
            } else if (item.title == "证书") {
                return;
            } else {
                this.$router.push({
                    path: item.url,
                });
            }
        },

        routeSubTo(item) {
            if (item.type == 1) {
                if (item.id) {
                    this.$router.push({
                        path: item.url,
                        query: {
                            activeName: item.title,
                            id: item.id,
                            contentType: item.contentType,
                        },
                    });
                } else {
                    this.$router.push({
                        path: item.url,
                        query: {
                            activeName: item.title,
                        },
                    });
                }
            }
            if (item.type == 2) {
                window.open(item.url, "_blank");
                return;
                //
                if (item.title == "BIM证书查询") {
                    // this.$Message.info("网站正在维护中")
                    this.$Modal.warning({
                        title: "提示",
                        content: "网站正在维护中",
                    });
                } else {
                    let routeUrl = this.$router.resolve({
                        path: item.url,
                    });
                    window.open(routeUrl.href, "_blank");
                    //   window.open(item.url);
                }
            }

            this.isActive = 9;
        },
    },
    computed: {
        menuDataFilter() {
            let val = this.$store.getters.getRouterName;
            let menuList = this.menuList;
            menuList.forEach((x) => {
                x.style = "";
                if (x.name === val) {
                    x.style = "background: #0b60a2;color: #fff;";
                }
            });
            return menuList;
        },
    },
};
</script>

<style scoped>
.header-warpper {
    width: 100%;
    height: 140px;
    z-index: 2;
    background: #fff;
    /* background: url(../../static/images/header_bg.png) repeat-x; */
}

.logo {
    padding-top: 38px;
}

.logo img {
    height: 62px;
}

.logo .tit {
    font-size: 28px;
    font-weight: 600;
    color: rgb(11, 99, 188);
    display: inline-block;
}

.logo .sub-tit {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: rgb(11, 99, 188);
    width: 336px;
    letter-spacing: 0.62px;
}

/*nav*/
.nav_box {
    width: 100%;
    height: 51px;
    background: #195482;
}

.nav_box > .nav {
    width: 1200px;
    margin: 0 auto;
}

.nav_box > .nav > li {
    width: 200px;
    height: 51px;
    text-align: center;
    position: relative;
    padding: 15px 0;
    /* background: url(../../static/images/nav_splider.png) no-repeat right center; */
}

.nav_box > .nav > li > a {
    font-size: 18px;
    color: #fff;
    display: block;
    border-right: 2px solid rgba(255, 255, 255, 0.2);
}

.nav_box > .nav > li:last-child > a {
    border-right: 0;
}

.nav_box > .nav > li:hover {
    background-color: rgba(25, 84, 130, 0.1) !important;
}

.nav_box > .nav > li:focus {
    background-color: #1554a2 !important;
}

.nav_box > .nav > li:first-child {
    /* width: 106px; */
}

.nav_box > .nav > li:first-child img {
    margin-top: 15px;
}

.nav_box > .nav > li > ul.nav_down {
    position: absolute;
    z-index: 99;
    left: 0;
    top: 51px;
    width: 121px;
    background: #1554a2;
}

.nav_box > .nav > li > ul > li {
    width: 109px;
    margin: 0 auto;
    /* padding-left: 18px; */
    border-bottom: 1px solid #225fab;
    text-align: center;
}

.nav_box > .nav > li > ul > li:first-child {
    border-top: 1px solid #225fab;
}

.nav_box > .nav > li > ul > li:hover {
    background: #0b7abe;
}

.nav_box > .nav > li > ul > li > a {
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
}

.nav_box > .nav > li > ul > li.lineHeight_special {
    padding: 10px 0;
    padding-left: 14px;
}

.nav_box > .nav > li > ul > li.lineHeight_special > a {
    line-height: 17px;
}

.nav_box > .nav > li > ul.nav_down_w1 {
    width: 200px;
    z-index: 99;
    position: absolute;
    right: 1;
    top: 51px;
    background: #195482;
    max-height: 0;
    transition: max-height 0.6s ease;
    z-index: 99999;
    overflow: hidden;
}

.nav_box > .nav > li > ul.nav_down_w1 > li {
    width: 166px;
}

.nav_box > .nav > li > ul.nav_down_w2 {
    z-index: 99;
    width: 250px;
    position: absolute;
    right: 1;
    top: 51px;
    background: #1554a2;
}

.nav_box > .nav > li > ul.nav_down_w2 > li {
    width: 230px;
}

.open {
    max-height: 500px !important;
    transition: max-height 0.3s;
}
</style>

<style>
.ivu-modal {
    top: 30% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue